<template>
    <div>
        <PanelHeader :togglePreLoader="togglePreLoader"/>
        <div class="section checkout-sec cart-sec">
            <div class="container">
                <div class="row">
                    <PanelSidebar :togglePreLoader="togglePreLoader"/>
                    <div class="col-lg-8">
                      <router-view :togglePreLoader="togglePreLoader"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PanelHeader from "@/components/Panel_Header.vue"
    import PanelSidebar from '@/components/Panel_Sidebar.vue'
    export default {
        props:{
          togglePreLoader: Function
        },
        components:{
            PanelHeader,
            PanelSidebar
        },
    }
</script>